'use strict';

var FaresOptimizerWebFareChartDirective = function FaresOptimizerWebFareChartDirective($timeout, FaresOptimizerWebFareChart) {
  return {
    restrict: 'E',
    replace: true,
    controller: 'FaresOptimizerWebFareChartController',
    template: require('../templates/fares-optimizer-web-fare-chart.html'),
    scope: {
      webFareChartData: '=',
      chartDataTitle: '='
    },
    link: function link($scope, element) {
      var chartElement = element.find('.web-fare-chart-container');
      var chart = new FaresOptimizerWebFareChart(chartElement, $scope);
      $scope.renderChartDataPresent = function (data) {
        chart.render(data);
      };
    }
  };
};
FaresOptimizerWebFareChartDirective.$inject = ['$timeout', 'FaresOptimizerWebFareChart'];
module.exports = FaresOptimizerWebFareChartDirective;